document.addEventListener('DOMContentLoaded', () => {
    const canvas = document.getElementById('CostDonutChart');
    if (!canvas) return;

    const ctx = canvas.getContext('2d');
    const categories = JSON.parse(canvas.dataset.categories || '[]');
    const values = JSON.parse(canvas.dataset.values || '[]');

    // Hole die Farbvariablen aus CSS
    const rootStyle = getComputedStyle(document.documentElement);
    const colorMaleish   = rootStyle.getPropertyValue('--color-maleish').trim();
    const colorFemaleish = rootStyle.getPropertyValue('--color-femaleish').trim();
    const colorNeutral   = rootStyle.getPropertyValue('--color-neutral').trim();

    // Helper: Hex-Farbe in RGBA umwandeln
    function hexToRGBA(hex, alpha) {
        hex = hex.replace(/^#/, '');
        if (hex.length === 3) {
            hex = hex.split('').map(char => char + char).join('');
        }
        const r = parseInt(hex.substring(0, 2), 16);
        const g = parseInt(hex.substring(2, 4), 16);
        const b = parseInt(hex.substring(4, 6), 16);
        return `rgba(${r}, ${g}, ${b}, ${alpha})`;
    }

    // Erstelle Glow-Gradienten für jedes Segment
    function createGradient(ctx, color) {
        const gradient = ctx.createLinearGradient(0, 0, 200, 200);
        gradient.addColorStop(0, hexToRGBA(color, 0.9)); // Dunklere Mitte
        gradient.addColorStop(0.5, hexToRGBA(color, 0.5)); // Mittlerer Glow
        gradient.addColorStop(1, hexToRGBA(color, 0.2)); // Äußerer Glow
        return gradient;
    }

    // Farben mit Glow
    const backgroundColors = [
        createGradient(ctx, colorMaleish),   // Zinsen
        createGradient(ctx, colorFemaleish), // Tilgung
        createGradient(ctx, colorNeutral)    // Hausgeld
    ];

    const hoverBackgroundColors = [
        hexToRGBA(colorMaleish, 1),
        hexToRGBA(colorFemaleish, 1),
        hexToRGBA(colorNeutral, 1)
    ];

    // Chart mit Schatten & Glow
    new Chart(ctx, {
        type: 'doughnut',
        data: {
            labels: categories,
            datasets: [{
                data: values,
                backgroundColor: backgroundColors,
                hoverBackgroundColor: hoverBackgroundColors,
                borderColor: hoverBackgroundColors,
                borderWidth: 2
            }]
        },
        options: {
            responsive: true,
            maintainAspectRatio: false,
            legend: {
                position: 'bottom'
            },
            cutoutPercentage: 70, // Donut-Stärke (kleiner = dünnerer Rand)
            animation: {
                animateScale: true,
                animateRotate: true
            },
            elements: {
                arc: {
                    borderWidth: 2,
                    shadowBlur: 15, // 🌟 Mehr Glow auf den Kreissegmenten
                    shadowColor: "rgba(255,255,255,0.3)", // Weißlicher Glow
                    hoverShadowBlur: 20,
                    hoverShadowColor: "rgba(255,255,255,0.5)"
                }
            }
        }
    });
});
